// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609091004/js/" + chunkId + "." + {"44":"7f70cf85","225":"6f4ad1f1","481":"b409f764","486":"96bfc289","770":"35f0574d"}[chunkId] + ".0.1660645408437068.chunk.js";
};